<style>
.analytics-data-wrapper {
    overflow: auto;
    iframe {
        height: calc(100vh - 133px  - 100px - 30px);
        width: 100%;
    }
}

@media (max-width: 991px){
    .analytics-data-wrapper {
        iframe {
            overflow: scroll;
            height: 62vh !important; 
            min-width: 1349px; 
        }
    }    
}
</style>
<div class="analytics-data-wrapper">
  <iframe id="wp-iframe" frameborder="0" width="100%" sandbox="allow-scripts allow-same-origin allow-forms"></iframe>
</div>